import { Sizes } from '@anm/components/SizeInputs';
import { DEFAULT_THUMBNAIL_WIDTH } from '@anm/constants/videoLandings';
import { useState } from 'react';

const useThumbnailSizes = (videoSizes: Sizes) => {
  const ratio = videoSizes?.width / videoSizes?.height;
  const thumbnailHeight = Math.round(DEFAULT_THUMBNAIL_WIDTH / ratio);

  const [sizes, setSizes] = useState({
    width: DEFAULT_THUMBNAIL_WIDTH,
    height: thumbnailHeight
  });

  return [sizes, setSizes] as const;
};

export default useThumbnailSizes;
